export default __webpack_public_path__ + "35ddf51967b4604ba14b5b5c4b4b76cb.png";